/** @format */

import { useQuery } from '@apollo/client';
import { GET_POLICY_BY_ID, GetPolicyByIdResponse, updateCustomer as updateCustomerService } from '../services/customerService';
import { Customer } from '../types/customer';
import { useState } from 'react';

export const useCustomer = (customerId: string | null) => {
  const [customer, setCustomer] = useState<Customer | null>(null);

  const { data, loading, error, refetch } = useQuery<GetPolicyByIdResponse>(GET_POLICY_BY_ID, {
    variables: { getPolicyByIdId: customerId || '' },
    skip: !customerId,
    onCompleted: (data) => {
      if (data?.getPolicyById) {
        setCustomer(data.getPolicyById);
      }
    },
  });

  const updateCustomer = async (updateData: Partial<Customer>) => {
    if (!customerId) return;

    try {
      await updateCustomerService(customerId, updateData);
      
      setCustomer((prev) => (prev ? { ...prev, ...updateData } : null));
      await refetch();
    } catch (err) {
      console.error('Error updating customer:', err);
      throw err;
    }
  };

  return {
    customer: customer || data?.getPolicyById || null,
    loading,
    error,
    updateCustomer,
    setCustomer,
    refetch,
  };
};
